import DashboardIcon from "@mui/icons-material/DashboardOutlined";
import StorefrontIcon from "@mui/icons-material/StorefrontOutlined";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLongOutlined";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutlineOutlined";
import SettingsIcon from "@mui/icons-material/SettingsOutlined";

const sidebarConfig = [
  { labelKey: "dashboard", path: "/business-owner/dashboard", icon: DashboardIcon },
  { labelKey: "myStores", path: "/business-owner/stores", icon: StorefrontIcon },
  { labelKey: "products", path: "/business-owner/products", icon: Inventory2OutlinedIcon },
  { labelKey: "orders", path: "/business-owner/orders", icon: ReceiptLongIcon },
  { labelKey: "messages", path: "/business-owner/messages", icon: ChatBubbleOutlineIcon, showUnreadBadge: true },
  { labelKey: "settings", path: "/business-owner/settings", icon: SettingsIcon },
];

export default sidebarConfig;
